import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import {
  Groups,
  AccountBalance,
  ReceiptLong,
  Engineering,
  AdminPanelSettings,
  People,
  Security,
  Work,
  Business,
  Settings,
  Assessment,
  Gavel,
} from "@mui/icons-material";

const ICON_MAP = {
  groups: Groups,
  account_balance: AccountBalance,
  receipt_long: ReceiptLong,
  engineering: Engineering,
  admin_panel_settings: AdminPanelSettings,
  people: People,
  security: Security,
  work: Work,
  business: Business,
  settings: Settings,
  assessment: Assessment,
  gavel: Gavel,
};

const COLOR_MAP = {
  purple: { bg: "#ede7f6", fg: "#673ab7" },
  blue: { bg: "#e8f0fe", fg: "#1a73e8" },
  green: { bg: "#e6f4ea", fg: "#34a853" },
  orange: { bg: "#fef7e0", fg: "#fa7b17" },
  teal: { bg: "#e0f2f1", fg: "#009688" },
  red: { bg: "#fce8e6", fg: "#ea4335" },
  cyan: { bg: "#e0f7fa", fg: "#00bcd4" },
  pink: { bg: "#fce4ec", fg: "#e91e63" },
  indigo: { bg: "#e8eaf6", fg: "#3f51b5" },
};

const CardPreview = ({
  icon = "groups",
  color = "blue",
  name = "Nome do Grupo",
  description = "",
  numPermissions = 0,
  ativo = true,
  previewLabel = "PRÉ-VISUALIZAÇÃO",
}) => {
  const IconComponent = ICON_MAP[icon] || Groups;
  const colors = COLOR_MAP[color] || COLOR_MAP.blue;

  return (
    <Box sx={{ pt: 2, borderTop: "1px solid #e8eaed" }}>
      <Typography
        variant="caption"
        sx={{ 
          mb: 1.5, 
          display: "block", 
          fontWeight: 500, 
          color: "#5f6368",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          fontSize: "12px"
        }}
      >
        {previewLabel}
      </Typography>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1.5,
          p: 1.5,
          border: "1px solid #e8eaed",
          borderRadius: "8px",
          bgcolor: "#f8f9fa",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            bgcolor: colors.bg,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.fg,
            flexShrink: 0,
          }}
        >
          <IconComponent sx={{ fontSize: 22 }} />
        </Box>
        <Box>
          <Typography variant="body2" fontWeight={500} color="#202124" sx={{ lineHeight: 1.3 }}>
            {name || "Nome do Grupo"}
          </Typography>
          <Typography variant="caption" color="#9aa0a6" sx={{ fontSize: "12px", lineHeight: 1.3 }}>
            {description || "Descrição do grupo"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CardPreview;
